import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Col, Container, Row } from "react-bootstrap";

import styles from "./Portfolio.module.css";
import "animate.css";
import { getFolio } from "../../Firebase/FirebaseFetch";
import { HashLoader } from "react-spinners";
const Portfolio = () => {
  const [fetchData, setFetchData] = useState([]);
  const [data, setData] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    setLoading(true);
    await getFolio().then((res) => {
      setFetchData(res);
    });
    setLoading(false);
  };
  useEffect(() => {
    const renderFolio = fetchData.map((item, index) => {
      return {
        visible: item._document.data.value.mapValue.fields.visible.booleanValue,
        id: index,
        image: item._document.data.value.mapValue.fields.image.stringValue,
        name: item._document.data.value.mapValue.fields.name.stringValue,
        category:
          item._document.data.value.mapValue.fields.category.stringValue,
        link: item._document.data.value.mapValue.fields.link.stringValue,
      };
    });
    const visibleItem = renderFolio.filter((item) => item.visible === true);
    setData(visibleItem);
    setItems(visibleItem);
  }, [fetchData]);

  const filterItem = (e) => {
    document
      .getElementById("filterBtn")
      .querySelector(".filterActive")
      .classList.remove("filterActive");
    document
      .getElementById(`${e.currentTarget.id}`)
      .classList.add("filterActive");
    if (e.currentTarget.id === "all") {
      setItems(data);
    } else {
      //filter data
      const updateItems = data.filter((curElem) => {
        return curElem.category === e.currentTarget.id;
      });

      setItems(updateItems);
    }
  };

  return (
    <>
      <Container id="portfolio" className={styles.portfolio}>
        {loading ? (
          <div className={styles.loading}>
            <HashLoader color="#ffffff" />
          </div>
        ) : (
          <div>
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                className="text-center animate__animated animate__fadeInDownBig"
                id="filterBtn"
              >
                <button
                  id="all"
                  className={`${styles.Button} filterBtn filterActive`}
                  onClick={filterItem}
                >
                  All
                </button>
                <button
                  id="bootstrap"
                  className={`${styles.Button} filterBtn `}
                  onClick={filterItem}
                >
                  Bootstrap
                </button>
                <button
                  id="javascript"
                  className={`${styles.Button} filterBtn`}
                  onClick={filterItem}
                >
                  JavaScript
                </button>
                <button
                  id="react"
                  className={`${styles.Button} filterBtn`}
                  onClick={filterItem}
                >
                  React
                </button>
                <button
                  id="app"
                  className={`${styles.Button} filterBtn`}
                  onClick={filterItem}
                >
                  Mobile App
                </button>
              </Col>
            </Row>
            <Row className="my-5">
              {items.slice(0, 12).map((elem) => {
                const { id, name, image, link } = elem;
                return (
                  <Col lg={3} md={4} sm={12} key={id}>
                    <motion.div
                      layout
                      key={id}
                      className={`${styles.card} my-3 animate__animated animate__fadeIn`}
                    >
                      <div>
                        <img
                          className={`${styles.img} img-fluid`}
                          src={image}
                          alt={name}
                        />
                      </div>
                      <div className={styles.cardOverlay}>
                        <h2>{name.toUpperCase()}</h2>
                        <a
                          href={link}
                          className={`${styles.title}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Live Preview
                        </a>
                      </div>
                    </motion.div>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </Container>
    </>
  );
};

export default Portfolio;
